import { keyframes } from '@emotion/react'
import { Box } from '@mui/material'
import NGLogo from '@/features/themedLogos/NGLogo'

const bounce1 = keyframes`
  0% {
    transform: translate3d(0, 0, 0);
  }
  50% {
    transform: translate3d(0, 15px, 0);
  }
  100% {
    transform: translate3d(0, 0, 0);
  }
`

// const bounce3 = keyframes`
//   0% {
//     transform: translate3d(0, 0, 0);
//   }
//   50% {
//     transform: translate3d(0, 15px, 0);
//   }
//   100% {
//     transform: translate3d(0, 0, 0);
//   }
// `

const SplashScreen = () => (
    <Box
        sx={{
            alignItems: 'center',
            backgroundColor: 'neutral.900',
            display: 'flex',
            flexDirection: 'column',
            height: '100vh',
            justifyContent: 'center',
            left: 0,
            p: 3,
            position: 'fixed',
            top: 0,
            width: '100vw',
            zIndex: 2000
        }}
    >
        <NGLogo
            sx={{
                height: 100,
                width: 100,
                '& path:nth-of-type(1)': {
                    animation: `${bounce1} 1s ease-in-out infinite`
                },
                '& rect:nth-of-type(1)': {
                    animation: `${bounce1} 1s ease-in-out infinite`
                },
                '& path:nth-of-type(2)': {
                    animation: `${bounce1} 1s ease-in-out infinite`
                },
                '& rect:nth-of-type(2)': {
                    animation: `${bounce1} 1s ease-in-out infinite`
                }
            }}
        />
    </Box>
)

export default SplashScreen
